export default "/images/vendor/@coreui/icons/svg/flag/cif-kg.svg?827773bb4f7dd39a256a4c082b5aa4a5";